import createConverter from './lib/create_converter';
import Team from 'models/team';

export default createConverter(Team);



// WEBPACK FOOTER //
// ./src/scripts/application/dto_converters/team_converter.js